// src/lib/authErrors.js
// Maps Firebase Auth error codes to friendly, human-readable copy.
// Pure (no Firebase imports) so it stays easy to test and reuse across
// the student (/signin) and admin (/login) doors.

const MESSAGES = {
  "auth/invalid-credential": "Invalid email or password. Please try again.",
  "auth/invalid-email": "That doesn't look like a valid email address.",
  "auth/user-disabled": "This account has been disabled. Please contact support.",
  "auth/user-not-found": "Invalid email or password. Please try again.",
  "auth/wrong-password": "Invalid email or password. Please try again.",
  "auth/missing-password": "Please enter your password.",
  "auth/too-many-requests": "Too many attempts. Please wait a moment and try again.",
  "auth/network-request-failed": "Network error. Check your connection and try again.",
  "auth/internal-error": "Something went wrong on our end. Please try again.",
};

const FALLBACK = "Unable to sign you in right now. Please try again.";

/**
 * @param {string|{code?: string}} error - a Firebase error code string, or a
 *   thrown error object with a `.code` property.
 * @returns {string} friendly message safe to show users.
 */
export function friendlyAuthError(error) {
  const code = typeof error === "string" ? error : error?.code;
  return MESSAGES[code] || FALLBACK;
}
